import { useEffect } from "react";

import { strFromAccTarget, createAccObjFromStr } from "../lib/helperFuncs.jsx";

export const useRoomRateParams = (
    rulesForChange,
    activeRoomTypes,
    getAllUniqueAccTypesFormRules,
    createAccomodTypes,
    setRulesForChange,
) => {
    useEffect(() => {
        const newAccTypes = getAllUniqueAccTypesFormRules(rulesForChange.data);

        const newRoomTypesIdsArr = rulesForChange.additional_room_types.map(
            (newRoomType) => newRoomType.room_type_id,
        );

        if (
            newRoomTypesIdsArr[0] !== 1 &&
            (JSON.stringify(newAccTypes) !==
                JSON.stringify(rulesForChange.selectedAccTypes) ||
                JSON.stringify(newRoomTypesIdsArr) !==
                    JSON.stringify(rulesForChange.selectedRoomTypesIds))
        ) {
            const updatedAdditionalRoomTypes = [
                ...rulesForChange.additional_room_types,
            ].map((addRoom) => {
                const accTypesToAdd = [];
                const updatedRoom = { ...addRoom };
                const addRoomData = activeRoomTypes.find(
                    (room) => room.id === updatedRoom.room_type_id,
                );
                const addRoomAccTypesArr = createAccomodTypes(
                    addRoomData.capacity,
                    addRoomData.data.babies_capacity,
                );
                const newAccTypesStrArr = newAccTypes.map((newAccType) =>
                    strFromAccTarget(newAccType),
                );

                newAccTypesStrArr.forEach((newAccTypeStr) => {
                    if (addRoomAccTypesArr.includes(newAccTypeStr)) {
                        return accTypesToAdd.push(
                            createAccObjFromStr(newAccTypeStr),
                        );
                    }
                });

                return {
                    ...updatedRoom,
                    accommodation_types: accTypesToAdd,
                };
            });

            setRulesForChange((prevState) => ({
                ...prevState,
                additional_room_types: updatedAdditionalRoomTypes,
                selectedAccTypes: newAccTypes,
                selectedRoomTypesIds: newRoomTypesIdsArr,
            }));
        }
    }, [
        rulesForChange.additional_room_types,
        rulesForChange.data,
        rulesForChange.base,
    ]);
};
